// extracted by mini-css-extract-plugin
export default {"Sluzby":"Sluzby_Sluzby__4WLHs","poskytujeme":"Sluzby_poskytujeme__Iy-rO","subPoskytujeme":"Sluzby_subPoskytujeme__n+tkq","poskytujemeItems":"Sluzby_poskytujemeItems__Rf7i-"};